export const changeStep = 10;
export const upperBound = 150;
export const bottomBound = 10;
